module.exports = __webpack_public_path__ + "img/5f98320032b4ea50318805e897e34e8f.png";